import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_URL || "https://api.nexflowcrm.com/api/v1";

const http = axios.create({ baseURL: `${BASE_URL}/branches` });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Pull the server's message out of an axios error, with a usable fallback. */
export function apiError(err, fallback = "Something went wrong") {
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.code === "ERR_NETWORK") return "Can't reach the server. Check your connection.";
  return fallback;
}

export const branchesApi = {
  async list(params = {}) {
    const { data } = await http.get("/get-all", { params });
    return data.data; // { items, total, page, limit }
  },

  async getById(id) {
    const { data } = await http.get(`/get-by-id/${id}`);
    return data.data;
  },

  async create(payload) {
    const { data } = await http.post("/create", payload);
    return data.data;
  },

  async update(id, payload) {
    const { data } = await http.put(`/update/${id}`, payload);
    return data.data;
  },

  async remove(id, reassignTo) {
    const { data } = await http.delete(`/delete/${id}`, {
      params: reassignTo ? { reassignTo } : undefined,
    });
    return data;
  },

  async toggleStatus(id) {
    const { data } = await http.patch(`/toggle-status/${id}`);
    return data;
  },

  async stats() {
    const { data } = await http.get("/stats");
    return data.data;
  },

  async users(id) {
    const { data } = await http.get(`/users/${id}`);
    return data.data;
  },
};

export default branchesApi;